import {
  SET_USER,
  CLEAR_ERRORS,
  SET_AUTHENTICATED,
  SET_UNAUTHENTICATED,
  LOADING_USER,
  STOP_LOADING_USER,
  MARK_NOTIFICATIONS_READ,
  SET_SCHEDULING_SETTINGS,
  SET_USER_ACTIVE_PLAN_DETAILS,
  SET_FAILING_PINTEREST_PROFILES,
  SET_FAILING_AUTHORIZED_PROFILES,
  // Add new social media types
  SET_SOCIAL_MEDIA_PROFILES,
  SET_ACTIVE_SOCIAL_MEDIA_PROFILES,
  ADD_SOCIAL_MEDIA_PROFILE,
  UPDATE_SOCIAL_MEDIA_PROFILE,
  REMOVE_SOCIAL_MEDIA_PROFILE,
  ACTIVATE_SOCIAL_MEDIA_PROFILE,
  SET_SOCIAL_MEDIA_LOADING,
  SET_SCHEDULED_POSTS,
  ADD_NEW_SCHEDULED_POST,
  DELETE_SCHEDULED_POST,
  UPDATE_SCHEDULED_POSTS,
  SET_IS_LOADING_SCHEDULED_POSTS,
  SET_REPEATING_POSTS,
  ADD_REPEATING_POSTS,
  SET_REPEATING_POST,
  ADD_NEW_REPEATING_POST,
  DELETE_REPEATING_POST,
  UPDATE_REPEATING_POSTS,
  SET_IS_LOADING_REPEATING_POSTS,
  INCREMENT_USED_POST_CREDITS,
  DECREMENT_USED_POST_CREDITS,
  SET_SHOP_PROFILES,
  SET_SCHEDULED_POST,
  SET_USER_PLAN_TO_ACTIVE,
  UPDATE_USER_CREDENTIALS,
  ADD_USER_MEDIA,
  SET_USER_MEDIA,
  DELETE_USER_MEDIA,
  TOGGLE_TEMPLATE_FAVORITE,
  ADD_SCHEDULED_POSTS,
  SET_SCHEDULED_POSTS_TOTAL_COUNT,
  SET_DRAFTS,
  PREPEND_DRAFT,
  DELETE_DRAFT,
  RENAME_DRAFT,
  APPEND_DRAFTS,
  SET_ONBOARDING_CHECKLIST,
} from "../types";

import { getDefaultSchedulingSettings } from "../../utils/utilityFunctions";

const initialState = {
  authenticated: false,
  credentials: {
    handle: "",
    email: "",
    image: "",
    createdAt: "",
    accountType: "",
    activePlan: "",
    userID: "",
    pinterestAccessToken: "",
    authorizedSocialMediaProfiles: {},
    activeSocialMediaProfiles: {},
    // Onboarding checklist - will be populated from server with current config
    onboardingChecklist: [],
  },
  // Add social media loading state
  socialMediaLoading: {},
  loading: false,
  errors: [],
  schedulingSettings: {
    ...getDefaultSchedulingSettings(),
  },
  scheduledPosts: [],
  scheduledPostsTotalCount: 0,
  isLoadingScheduledPosts: false,
  activePlanDetails: {},
  media: [],
  favoriteTemplates: [],
  failingAuthorizedProfiles: [],
  drafts: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_AUTHENTICATED:
      return {
        ...state,
        authenticated: true,
      };
    case SET_UNAUTHENTICATED:
      return initialState;
    case SET_USER:
      return {
        ...state,
        ...action.payload,
        authenticated: true,
        loading: false,
        favoriteTemplates: action.payload.favoriteTemplates
          ? action.payload.favoriteTemplates
          : [],
      };
    case LOADING_USER:
      return {
        ...state,
        loading: true,
      };
    case STOP_LOADING_USER:
      return {
        ...state,
        loading: false,
      };
    case MARK_NOTIFICATIONS_READ:
      return {
        ...state,
        notifications: (state.notifications || []).map((not) => ({
          ...not,
          read: true,
        })),
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        errors: [],
      };

    // NEW SOCIAL MEDIA PROFILE CASES

    case SET_SOCIAL_MEDIA_PROFILES:
      return {
        ...state,
        credentials: {
          ...state.credentials,
          authorizedSocialMediaProfiles: action.payload,
        },
      };

    case SET_ACTIVE_SOCIAL_MEDIA_PROFILES:
      return {
        ...state,
        credentials: {
          ...state.credentials,
          activeSocialMediaProfiles: action.payload,
        },
      };

    case ADD_SOCIAL_MEDIA_PROFILE:
      return {
        ...state,
        credentials: {
          ...state.credentials,
          authorizedSocialMediaProfiles: {
            ...state.credentials.authorizedSocialMediaProfiles,
            [action.payload.platform]: [
              ...state.credentials.authorizedSocialMediaProfiles[
                action.payload.platform
              ],
              action.payload.profile,
            ],
          },
        },
      };

    case UPDATE_SOCIAL_MEDIA_PROFILE:
      return {
        ...state,
        credentials: {
          ...state.credentials,
          authorizedSocialMediaProfiles: {
            ...state.credentials.authorizedSocialMediaProfiles,
            [action.payload.platform]:
              state.credentials.authorizedSocialMediaProfiles[
                action.payload.platform
              ].map((profile) =>
                profile.username === action.payload.profile.username
                  ? action.payload.profile
                  : profile
              ),
          },
        },
      };

    case REMOVE_SOCIAL_MEDIA_PROFILE:
      return {
        ...state,
        credentials: {
          ...state.credentials,
          authorizedSocialMediaProfiles: {
            ...state.credentials.authorizedSocialMediaProfiles,
            [action.payload.platform]:
              state.credentials.authorizedSocialMediaProfiles[
                action.payload.platform
              ].filter(
                (profile) => profile.username !== action.payload.username
              ),
          },
          activeSocialMediaProfiles: {
            ...state.credentials.activeSocialMediaProfiles,
            [action.payload.platform]:
              state.credentials.activeSocialMediaProfiles[
                action.payload.platform
              ] === action.payload.username
                ? null
                : state.credentials.activeSocialMediaProfiles[
                    action.payload.platform
                  ],
          },
        },
      };

    case ACTIVATE_SOCIAL_MEDIA_PROFILE:
      return {
        ...state,
        credentials: {
          ...state.credentials,
          authorizedSocialMediaProfiles: {
            ...state.credentials.authorizedSocialMediaProfiles,
            [action.payload.platform]:
              state.credentials.authorizedSocialMediaProfiles[
                action.payload.platform
              ].map((profile) => ({
                ...profile,
                isActive: profile.username === action.payload.username,
              })),
          },
          activeSocialMediaProfiles: {
            ...state.credentials.activeSocialMediaProfiles,
            [action.payload.platform]: action.payload.username,
          },
        },
      };

    case SET_SOCIAL_MEDIA_LOADING:
      return {
        ...state,
        socialMediaLoading: {
          ...state.socialMediaLoading,
          [`${action.payload.platform}_${action.payload.username}`]:
            action.payload.loading,
        },
      };

    case SET_SCHEDULING_SETTINGS:
      return {
        ...state,
        schedulingSettings: action.payload,
      };
    case SET_SCHEDULED_POSTS:
      return {
        ...state,
        scheduledPosts: action.payload,
      };
    case ADD_SCHEDULED_POSTS:
      return {
        ...state,
        scheduledPosts: [...state.scheduledPosts, ...action.payload],
      };
    case SET_SCHEDULED_POST:
      let postsWithUpdatedPost = state.scheduledPosts.map((post) => {
        if (post.id == action.payload.id) {
          return action.payload;
        } else {
          return post;
        }
      });

      return {
        ...state,
        scheduledPosts: postsWithUpdatedPost,
      };
    case ADD_NEW_SCHEDULED_POST:
      return {
        ...state,
        scheduledPosts: [...state.scheduledPosts, action.payload],
      };
    case DELETE_SCHEDULED_POST:
      return {
        ...state,
        scheduledPosts: state.scheduledPosts.filter(
          (post) => post.id != action.payload
        ),
      };
    case UPDATE_SCHEDULED_POSTS: {
      const updatedPostsMap = new Map();
      action.payload.forEach((updatedPost) => {
        updatedPostsMap.set(updatedPost.id, updatedPost);
      });

      const mergedPosts = state.scheduledPosts.map((post) => {
        const updated = updatedPostsMap.get(post.id);
        return updated || post;
      });

      const sortedPosts = [...mergedPosts].sort((a, b) =>
        a.scheduledTime > b.scheduledTime
          ? 1
          : b.scheduledTime > a.scheduledTime
          ? -1
          : 0
      );

      return {
        ...state,
        scheduledPosts: sortedPosts,
      };
    }
    case SET_IS_LOADING_SCHEDULED_POSTS:
      return {
        ...state,
        isLoadingScheduledPosts: action.payload,
      };
    case INCREMENT_USED_POST_CREDITS:
      return {
        ...state,
        credentials: {
          ...state.credentials,
          usedPostCredits: state.credentials.usedPostCredits + action.payload,
        },
      };
    case DECREMENT_USED_POST_CREDITS:
      return {
        ...state,
        credentials: {
          ...state.credentials,
          usedPostCredits: state.credentials.usedPostCredits - 1,
        },
      };
    case SET_USER_ACTIVE_PLAN_DETAILS:
      return {
        ...state,
        activePlanDetails: action.payload,
      };
    case SET_SHOP_PROFILES:
      return {
        ...state,
        credentials: { ...state.credentials, authorizedShops: action.payload },
      };
    case SET_USER_PLAN_TO_ACTIVE:
      return {
        ...state,
        credentials: {
          ...state.credentials,
          ...action.payload,
          planStatus: "Active",
        },
      };
    case UPDATE_USER_CREDENTIALS:
      return {
        ...state,
        credentials: {
          ...state.credentials,
          ...action.payload,
        },
      };
    case ADD_USER_MEDIA:
      return {
        ...state,
        media: [...action.payload, ...state.media],
      };
    case SET_USER_MEDIA:
      let allMedia = [...state.media, ...action.payload];

      // Deduplicate the media on id
      let uniqueMedia = [];
      let uniqueMediaIds = [];

      allMedia.forEach((media) => {
        if (!uniqueMediaIds.includes(media.id)) {
          uniqueMedia.push(media);
          uniqueMediaIds.push(media.id);
        }
      });

      // Order by createdAt
      uniqueMedia.sort((a, b) =>
        a.createdAt > b.createdAt ? -1 : b.createdAt > a.createdAt ? 1 : 0
      );

      return {
        ...state,
        media: [...uniqueMedia],
      };
    case DELETE_USER_MEDIA:
      let newMedia = state.media;
      // remove the media with the same id from the array
      newMedia = newMedia.filter((media) => media.id !== action.payload);
      return {
        ...state,
        media: [...newMedia],
      };
    case TOGGLE_TEMPLATE_FAVORITE: {
      const isFavorited = state.favoriteTemplates.includes(action.payload);
      return {
        ...state,
        favoriteTemplates: isFavorited
          ? state.favoriteTemplates.filter((t) => t !== action.payload)
          : [...state.favoriteTemplates, action.payload],
      };
    }
    case SET_FAILING_AUTHORIZED_PROFILES:
      return {
        ...state,
        failingAuthorizedProfiles: action.payload,
      };
    case SET_SCHEDULED_POSTS_TOTAL_COUNT:
      return {
        ...state,
        scheduledPostsTotalCount: action.payload,
      };
    case SET_DRAFTS:
      return {
        ...state,
        drafts: action.payload,
      };
    case APPEND_DRAFTS:
      let drafts = state.drafts;
      drafts = drafts.concat(action.payload);
      return {
        ...state,
        drafts: drafts,
      };
    case PREPEND_DRAFT:
      return {
        ...state,
        drafts: [action.payload, ...state.drafts],
      };
    case DELETE_DRAFT:
      return {
        ...state,
        drafts: state.drafts.filter((draft) => draft.id != action.payload),
      };
    case RENAME_DRAFT:
      return {
        ...state,
        drafts: state.drafts.map((draft) =>
          draft.id == action.payload.draftId
            ? { ...draft, name: action.payload.newName }
            : draft
        ),
      };
    case SET_ONBOARDING_CHECKLIST:
      return {
        ...state,
        credentials: {
          ...state.credentials,
          onboardingChecklist: action.payload,
        },
      };
    default:
      return state;
  }
}
